/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const LotteryStatuses = Object.freeze({
    DRAFTED: 0,
    DISPLAYED: 1,
    OPENED: 2,
    CLOSED: 3,
    EXECUTING: 4,
    EXECUTED: 5,
    NOTIFIED: 6,
    ARCHIVED: 7,
});

export const LotteryApplicationStatuses = Object.freeze({
    LOTTERY_IN_PROGRESS: 2,
    LOTTERY_APPLIED: 3,
    LOTTERY_AWARDED: 4,
    LOTTERY_LOST: 6,
    LOTTERY_DECLINED: 7,
    LOTTERY_ACCEPTED: 8,
    LOTTERY_NO_RESPONSE: 9,
    LOTTERY_CANCELLED: 14,
    LOTTERY_VOIDED: 16,
    LOTTERY_DISQUALIFIED: 17,
    LOTTERY_PENDING: 19,
});

export const SalesChannelTypes = Object.freeze({
    ONLINE: 0,
    FIELD_SALES: 1,
    CALL_CENTER: 2,
});

export const AcquisitionTypes = Object.freeze({
    WALKUP: 0,
    DAY_BEFORE_WALKUP: 1,
    LOTTERY: 2,
    RESERVED: 3,
});

export const AnimalTypeAsString = new Map();
AnimalTypeAsString.set(1, 'Goat');
AnimalTypeAsString.set(2, 'Horse / Pack Mule');
AnimalTypeAsString.set(3, 'Llama');
AnimalTypeAsString.set(4, 'Dog');
AnimalTypeAsString.set(5, 'Horse/Mule Riding Stock');
AnimalTypeAsString.set(6, 'Dogs or other pets');
AnimalTypeAsString.set(7, 'Burro');
AnimalTypeAsString.set(8, 'Mule');
AnimalTypeAsString.set(9, 'Riding Horse');
AnimalTypeAsString.set(10, 'Stock Horse');
AnimalTypeAsString.set(999999, 'Other');
